/* UTILS */
import { useInfiniteQuery, useQuery } from '@tanstack/vue-query';

import { getCurrentBatches, getCurrentBatchesSummary } from '@/api/calls/batches/batches.api';
/* HELPERS */
import { getCacheDuration, getNextPageValue } from '@/api/helpers/helpers';

export function useGetBatchesQuery() {
  return useInfiniteQuery({
    queryKey: ['getBatches'],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => getCurrentBatches(pageParam),
    getNextPageParam: getNextPageValue,

    // options
    staleTime: getCacheDuration('medium')
  });
}

export function useGetBatchesSummaryQuery() {
  return useQuery({
    queryKey: ['getBatchesSummary'],
    queryFn: getCurrentBatchesSummary,

    // options
    staleTime: getCacheDuration('x-long')
  });
}
